<template>
    <div id='loaderdash' v-if="display">
        <section id='logo-loader'>
            <icon-svg icon-name="sellsy" class="secondary-blue"><icon-sellsy-cloud/></icon-svg>
        </section>
    </div>
</template>

<script>
    import IconSvg from 'vcomponents/icons/IconSvg.vue';
    import IconSellsyCloud from 'vcomponents/icons/IconSvgLogoSellsyCloud.vue';

    export default {
        props: {
            display: {
                type: Boolean,
                required: true
            }
        },
        data(){
            return {
            }
        },
        components: {
            IconSvg,
            IconSellsyCloud
        }
    }
</script>
